import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import RollForwardPreview from "../components/rollforward/RollForwardPreview";
import { canManage } from "../utils/roles";

const CATEGORIES = [
  { key: "personal", label: "Personal" },
  { key: "corporate", label: "Corporate" },
  { key: "tslips", label: "T-Slips" },
  { key: "other", label: "Other" },
];

// Every roll-forward endpoint is manager-only and returns 403 otherwise, so
// a staff user landing here directly would see an error-filled screen
// without this gate.

export default function RollForwardRunPage({ user }) {
  const navigate = useNavigate();
  const thisYear = new Date().getFullYear();
  const [fiscalYear, setFiscalYear] = useState(thisYear - 1);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (!user || !canManage(user)) {
      navigate("/");
    }
  }, [user, navigate]);

  const years = useMemo(
    () => Array.from({ length: 8 }, (_, i) => thisYear - i),
    [thisYear],
  );

  const scope = useMemo(() => {
    const base = { kind: "firm", fiscal_year: fiscalYear };
    return categories.length ? { ...base, categories } : base;
  }, [fiscalYear, categories]);

  const toggleCategory = (key) =>
    setCategories((prev) =>
      prev.includes(key) ? prev.filter((c) => c !== key) : [...prev, key],
    );

  if (!user || !canManage(user)) return null;

  return (
    <div style={{ padding: 24, maxWidth: 1100 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0, color: "#111827" }}>
        Roll forward
      </h1>
      <p style={{ fontSize: 13, color: "#6b7280", marginTop: 6, marginBottom: 20 }}>
        Nothing is created until you press the button. Rows are ticked using your
        roll-forward settings — you can tick anything else you want included.
      </p>

      <div style={{ display: "flex", gap: 16, alignItems: "center", marginBottom: 20, flexWrap: "wrap" }}>
        <label style={{ fontSize: 13, display: "flex", gap: 8, alignItems: "center" }}>
          Fiscal year
          <select
            aria-label="Fiscal year"
            value={fiscalYear}
            onChange={(e) => setFiscalYear(Number(e.target.value))}
            style={{ border: "1px solid #d1d5db", borderRadius: 6, padding: "6px 8px", fontSize: 13 }}
          >
            {years.map((y) => (
              <option key={y} value={y}>{`FY${y} → FY${y + 1}`}</option>
            ))}
          </select>
        </label>

        <div style={{ display: "flex", gap: 6 }}>
          {CATEGORIES.map((c) => {
            const on = categories.includes(c.key);
            return (
              <button
                key={c.key}
                onClick={() => toggleCategory(c.key)}
                style={{
                  fontSize: 13, padding: "6px 12px", borderRadius: 999,
                  border: `1px solid ${on ? "#0073ea" : "#d1d5db"}`,
                  background: on ? "#e6f4ff" : "white",
                  color: on ? "#0073ea" : "#676879",
                  cursor: "pointer", fontWeight: 600,
                }}
              >
                {c.label}
              </button>
            );
          })}
        </div>
      </div>

      <RollForwardPreview scope={scope} />
    </div>
  );
}
